import { Router, Route, lazy } from "preact-iso";
import Alert from "@mui/material/Alert";
import { Layout } from "./pages/Layout";
import { MobileLayout } from "./pages/MobileLayout";
import { useMediaQuery } from "@mui/material";

function NotFound() {
  return <Alert severity="error">Page not found</Alert>;
}

const Audiences = lazy(() => import("./pages/Audiences"));
const Turf = lazy(() => import("./pages/turf/Turf"));
const Surveys = lazy(() => import("./pages/Surveys"));
const Launches = lazy(() => import("./pages/Launches"));
const Progress = lazy(() => import("./pages/Progress"));
const Metrics = lazy(() => import("./pages/Metrics"));
const TurfAssign = lazy(() => import("./pages/turf/TurfAssign"));
const Reports = lazy(() => import("./pages/Reports"));

export function AppRouter() {
  const desktop = useMediaQuery("(min-width:750px)", { noSsr: true });
  return desktop ? (
    <Layout>
      <Router>
        <Route path="/" component={Audiences} />
        <Route path="/audiences/:aud_id?" component={Audiences} />
        <Route path="/turf" component={Turf} />
        <Route path="/launches/:launchId?" component={Launches} />
        <Route path="/surveys" component={Surveys} />
        <Route path="/progress/:launchId?" component={Progress} />
        <Route path="/metrics" component={Metrics} />
        <Route path="/reports" component={Reports} />
        <Route default component={NotFound} />
      </Router>
    </Layout>
  ) : (
    <MobileLayout>
      <Router>
        <Route path="/:launchId?" component={TurfAssign} />
        <Route default component={NotFound} />
      </Router>
    </MobileLayout>
  );
}
